/**
 * Sol Invictus - Entry Point
 * High-fidelity 3D visualization of helios-proximal energy architecture
 *
 * Scientific data verified from NASA, ITER, NREL, IEA (December 2025)
 */

import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/main.css';

// Mount React application
const root = document.getElementById('root');

if (root) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
} else {
  console.error('Root element not found');
}
